import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog as PrimeReactDialog } from "primereact/dialog";
import "./Dialog.css";
import ErrorBoundary from "../ErrorBoundary";
const Dialog = (props) => {
    return (_jsx(ErrorBoundary, { children: _jsx(PrimeReactDialog, Object.assign({ dismissableMask: true }, props, { position: "center", draggable: false, focusOnShow: false, resizable: false, blockScroll: true, closable: true, closeOnEscape: false }, { children: props.children })) }));
};
export default Dialog;
